import Flex from "app/components/UI/Flex";
import Icon from "app/components/UI/Icon";
import PropTypes from "prop-types";
import React from "react";
import classes from "./RaisedText.module.css";
import classnames from "classnames";

export const RaisedText = ({ className, children, label, isCollapsed, onToggleCollapse, isTransform }) => (
  <div
    className={classnames(className, classes.raisedText, {
      [classes.isTransform]: isTransform
    })}
  >
    <Flex
      direction="row"
      middle
      onClick={onToggleCollapse}
      className={classnames(classes.raisedText__content, classes.collapse__handle)}
    >
      <Flex size={1} className={classes.raisedText__label}>
        {label}
      </Flex>
      <div>
        {isCollapsed ? (
          <Icon className={classes.iconRight}>expand_less</Icon>
        ) : (
          <Icon className={classes.iconRight}>expand_more</Icon>
        )}
      </div>
    </Flex>
    <div
      className={classnames(classes.collapseContainer, {
        [classes.isCollapsed]: isCollapsed
      })}
    >
      <div className={classes.collapse__content}>{children}</div>
    </div>
  </div>
);

RaisedText.propTypes = {
  label: PropTypes.string.isRequired,
  className: PropTypes.string,
  children: PropTypes.node,
  isCollapsed: PropTypes.bool.isRequired,
  onToggleCollapse: PropTypes.func.isRequired,
  isTranform: PropTypes.bool
};

export default RaisedText;



// WEBPACK FOOTER //
// ./src/app/components/UI/RaisedText/RaisedTextCollapsible.js